<template>

  <div>

    <component :is="el" :label="label" :required="required">
      <i v-if="noForm">{{label}}&nbsp;</i>

      <el-select
      v-model.trim="formData"
      value-key="id"
      :disabled="disabled"
      :placeholder="placeholder"
      filterable
      remote
      :remote-method="findLandlordList"
      :loading="loading"
      @change="updated">

      <el-option
        v-for="org in this.landlords"
        :key="org.id"
        :label="org.name"
        :value="org">
        <span style="float: left">{{ org.name }}</span>
        <span style="float: right; color: #8492a6; font-size: 13px">
          {{ org.shortName }}
        </span>
      </el-option>

      </el-select>
    </component>

  </div>

</template>

<script>

import SiteMixins from '@/mixins/SiteMixins'

export default {
  name: 'select-landlord',

  mixins: [SiteMixins],

  props: {

    label: {
      type: String,
      default: 'Landlord'
    },

    value: {
//      type: [String, Object, Number],
      required: true
    },

    disabled: {
      type: Boolean,
      default: false
    },

    required: {
      type: Boolean,
      default: false
    },

    fullObject: {
      type: Boolean,
      default: false
    },

    placeholder: {
      type: String,
      default: 'Enter name (min 3 letters)'
    },

    helpText: {
      type: String,
      default: null
    },

    callback: {
      type: Function,
      default: null
    },

    noForm: {
      type: Boolean,
      default: false
    }

  },



  methods: {

    updated (org) {
      this.$emit('input', this.fullObject ? org : org.id)
      this.$emit('change', this.fullObject ? org : org.id)
    },

    findLandlordList (value) {
      if (value) {
        this.filterLandlords(value, this.findCallback)
      }
    },

    findCallback (response) {
      this.landlords = response
    }

  },



  data () {

    return {
      formData: this.value,
      loading: false,
      landlords: [],
      el: this.noForm ? 'div' : 'el-form-item'
    }

  }

}
</script>

<stype scoped>
  .el-select {
    display: inline-block;
    width: 100%;
  }
</style>
